export default "__VITE_ASSET__cNZlxuon__"